import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetCompetitionOffersQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform: Types.Platform;
	timezoneOffset: Types.Scalars['Int']['input'];
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	groupBy: Types.SportEventAggregation;
	first: Types.Scalars['Int']['input'];
	bucketSize?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetCompetitionOffersQuery = {
	__typename?: 'Query';
	sportEventBucketsV2: {
		__typename?: 'SportEventBucketsConnectionV2';
		edges?: Array<{
			__typename?: 'SportEventBucketsEdgeV2';
			key: {
				__typename?: 'SportEventAggregationKeyV2';
				competition?: {
					__typename?: 'SportCompetitionV2';
					content: {
						__typename?: 'SportCompetitionContentV2';
						name: string;
						iconUrl?: string | null;
						iconBlurHash?: string | null;
						fullPath: string;
					};
				} | null;
			};
			node: {
				__typename?: 'SportEventsConnectionV2';
				edges?: Array<{
					__typename?: 'SportEventsEdgeV2';
					node:
						| {
								__typename?: 'MultiStepSportEvent';
								offers: Array<{
									__typename?: 'SportOffer';
									package: { __typename?: 'Package'; id: string; shortName: string };
								}>;
								content: { __typename?: 'MultiStepSportEventContent'; name: string };
						  }
						| {
								__typename?: 'SingleStepSportEvent';
								offers: Array<{
									__typename?: 'SportOffer';
									package: { __typename?: 'Package'; id: string; shortName: string };
								}>;
								content: { __typename?: 'SingleStepSportEventContent'; name: string };
						  };
				}> | null;
			};
		}> | null;
	};
};

export const GetCompetitionOffersDocument = gql`
	query GetCompetitionOffers(
		$country: Country!
		$language: Language!
		$platform: Platform!
		$timezoneOffset: Int!
		$filter: SportEventFilter
		$groupBy: SportEventAggregation!
		$first: Int!
		$bucketSize: Int
	) {
		sportEventBucketsV2(
			country: $country
			timezoneOffset: $timezoneOffset
			groupBy: $groupBy
			filter: $filter
			first: $first
			bucketSize: $bucketSize
		) {
			edges {
				key {
					competition {
						content(country: $country, language: $language) {
							name
							iconUrl
							iconBlurHash
							fullPath
						}
					}
				}
				node {
					edges {
						node {
							offers(country: $country, platform: $platform, filter: { bestOnly: false }) {
								package {
									id
									shortName
								}
							}
							content(country: $country, language: $language) {
								name
							}
						}
					}
				}
			}
		}
	}
`;
